import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { TemplateDocumentService } from "../../../../auth/service/template-document.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";
import { IDocumentUserTemplate } from "app/auth/models/document-id";

@Component({
  selector: "app-template-document-to-user",
  templateUrl: "./template-document-to-user.component.html",
  styleUrls: ["./template-document-to-user.component.scss"],
  animations: [
    trigger("childAnimation", [
      // ...
      state(
        "open",
        style({
          opacity: 1,
        }),
      ),
      state(
        "closed",
        style({
          display: "none",
          height: "0",
          opacity: 0,
        }),
      ),
      transition("* => *", [animate("0.5s")]),
    ]),
  ],
})
export class TemplateDocumentToUserComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKeyword: string = "";
  public tableLimit: number = 10;
  public userList: IDocumentUserTemplate[] = [];
  public userFilteredList: IDocumentUserTemplate[] = [];
  public isAChild: boolean = false;
  public pageBasicText: number = 1;
  public pageSize: number = 10;
  public isDisabled: boolean = true;
  public filter_onboarding: string | number = "all";
  public current_user: ICurrentUser;

  constructor(
    public _templateDocumentService: TemplateDocumentService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _router: Router,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.TEMPLATE_USER_LIST,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.TEMPLATE_USER_LIST,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_document_template_employee_list")) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    this._utilService.showLoading();
    this.current_user = await this._authenticationService.getCurrentUser();
    await this.loadUserList();
    this._utilService.hideLoading();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.pageSize = Number(event.target.value);
  }

  async loadUserList() {
    this.userList = await this._templateDocumentService.getUserTemplateList();
    this.userFilterList();
  }

  userFilterList() {
    this.isDisabled = true;
    this.userFilteredList = this.userList;

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 1) {
      this.userFilteredList = this.userList.filter((item: IDocumentUserTemplate) => item.complete_name.toLowerCase().includes(keywords));
    }
    if (this.filter_onboarding !== "all") {
      this.userFilteredList = this.userList.filter((item: IDocumentUserTemplate) => item.send_onboarding == this.filter_onboarding);
    }

    setTimeout(() => {
      this.isDisabled = false;
      this._utilService.hideLoading();
    }, 1000);
  }

  resetShowFile(row: IDocumentUserTemplate) {
    row.show_file = !row.show_file;

    this.userList.map((item: IDocumentUserTemplate) => {
      if (row.complete_name !== item.complete_name) {
        item.show_file = false;
      }
    });
  }

  setDisabledAnimation() {
    this.isDisabled = true;

    setTimeout(() => {
      this.isDisabled = false;
    }, 1000);
  }

  async sendDocument(user: IDocumentUserTemplate, template_id: number) {
    if (!this._authenticationService.hasCapability("send_document_template")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    const data: { users: string[] } = {
      users: [user.hash],
    };
    this._utilService.showLoading();
    await this._templateDocumentService
      .sendDocumentTemplate(data, String(template_id))
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "DOCUMENT_SEND_SUCCESS" });
        this.userFilteredList = this.userFilteredList.filter((item) => item.complete_name === user.complete_name);
        this.userFilteredList[0].templates.map((template) => {
          if (template.id === template_id) {
            template.status = 2;
          }
        });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "DOCUMENT_SEND_ERROR" });
      });
  }
}
